const map = {
	"./ar/help.jpg": 88407,
	"./de/help.jpg": 45951,
	"./en/help.jpg": 68359,
	"./fr/help.jpg": 52488,
	"./it/help.jpg": 4397,
	"./kh/help.jpg": 14011,
	"./krt/help.jpg": 89169,
	"./nl/help.jpg": 15822,
	"./tr/help.jpg": 34714
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88209;